export enum UpdateURLStrategy {
	REPLACE,
	ADD
}

export type ObjectKey = string | number;
